import React, { useEffect, useState } from "react"
import AuthCard from "../components/AuthCard"
import FormInput from "../components/FormInput"
import requests from "../api/requests"
import Button from "../components/Button"
import { useSnackbar } from "react-simple-snackbar"
import {
  errorSnackBar,
} from "../components/snackBarOptions"
import { useLocation, useNavigate } from "react-router-dom"
import { EmailConfirmationModal } from "../components/EmailModal"

import { faEnvelope } from "@fortawesome/free-solid-svg-icons"

function EmailScreen() {
  const [email, setEmail] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [openErrorSnackbar] = useSnackbar(errorSnackBar)
  const [showEmailConfirmation, setShowEmailConfirmation] = useState(false)
  const [newMemberData, setNewMemberData] = useState(null)
  const [emailCountdown, setEmailCountdown] = useState(5);

  // Timer para countdown do modal de confirmação de email
  useEffect(() => {
    if (showEmailConfirmation && emailCountdown > 0) {
      const timer = setTimeout(() => {
        setEmailCountdown(prev => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [showEmailConfirmation, emailCountdown]);

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const source = searchParams.get("source")

  const navigate = useNavigate()

  const input = {
    id: 1,
    name: "email",
    type: "email",
    placeholder: "Email",
    errorMessage: "Preencha com um email válido",
    label: "Email",
    required: true,
    autoFocus: true,
  }

  const checkEmail = async (e) => {
    e.preventDefault()

    const formElement = e.target
    const isValid = formElement.checkValidity()
    if (!isValid) {
      openErrorSnackbar("Preencha com um email válido")
      return
    }
    try {
      setIsLoading(true)
      const resp = await requests.checkEmail(email)
      const { data } = resp

      if (data.isMember) {
        navigate("/signin", { state: { email: email, name: data.name } })
        return
      } else {
        // Para novos membros, mostrar modal de confirmação de email primeiro
        const memberData = {
          email: email,
          source: source,
          acceptNewMembers: data.acceptNewMembers,
          ...(data.isAlumyMember && {
            name: data.alumyName,
            isAlumyMember: data.isAlumyMember,
          })
        }
        
        setNewMemberData(memberData)
        setEmailCountdown(5);
        setShowEmailConfirmation(true)
        return
      }
    } catch (error) {
      openErrorSnackbar("O email informado não é válido")
    } finally {
      setIsLoading(false)
    }
  }

  const onChange = (e) => {
    setEmail(e.target.value)
  }

  const handleEmailConfirm = () => {
    // Navegar para signup com os dados confirmados
    navigate("/signup", { state: newMemberData })
    setShowEmailConfirmation(false)
  }

  const handleEmailCancel = () => {
    // Voltar para editar o email
    setShowEmailConfirmation(false)
    setNewMemberData(null)
  }

  return (
    <>
      <AuthCard>
        <h1>Bem-vindo!</h1>
        <h2>Informe seu e-mail para continuar</h2>
        <form onSubmit={checkEmail} noValidate autoComplete="off">
          <FormInput
            key={input.id}
            {...input}
            value={email}
            onChange={onChange}
            icon={faEnvelope}
          />
          <Button text="Próximo" isLoading={isLoading} />
        </form>
      </AuthCard>
      <EmailConfirmationModal
        isOpen={showEmailConfirmation}
        email={email}
        onConfirm={handleEmailConfirm}
        onCancel={handleEmailCancel}
        countdown={emailCountdown}
      />
    </>
  )
}

export default EmailScreen
